"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_jss_1 = __importDefault(require("react-jss"));

exports.default = react_jss_1.default({
  modalBackdrop: {
    opacity: 0,
    cursor: 'pointer',
    transform: 'translate3d(0, 100%, 0)',
    transition: 'opacity 0.3s ease-in, transform 0s ease-in 0.3s'
  },
  show: {
    transform: 'translate3d(0, 0, 0)',
    transition: 'opacity 0.3s ease-in'
  }
});